/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VenueRouteImport } from './routes/venue'
import { Route as SponsorsRouteImport } from './routes/sponsors'
import { Route as SpeakersRouteImport } from './routes/speakers'
import { Route as PastEventsRouteImport } from './routes/past-events'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AgendaRouteImport } from './routes/agenda'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SponsorsSponsorIdRouteImport } from './routes/sponsors.$sponsorId'
import { Route as SpeakersSpeakerIdRouteImport } from './routes/speakers.$speakerId'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as AdminVenueRouteImport } from './routes/admin/venue'
import { Route as AdminSponsorsRouteImport } from './routes/admin/sponsors'
import { Route as AdminSpeakersRouteImport } from './routes/admin/speakers'
import { Route as AdminRegistrationsRouteImport } from './routes/admin/registrations'
import { Route as AdminMediaRouteImport } from './routes/admin/media'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminHomepageRouteImport } from './routes/admin/homepage'
import { Route as AdminGalleryRouteImport } from './routes/admin/gallery'
import { Route as AdminEventRouteImport } from './routes/admin/event'
import { Route as AdminAgendaRouteImport } from './routes/admin/agenda'
import { Route as AdminAboutRouteImport } from './routes/admin/about'

const VenueRoute = VenueRouteImport.update({
  id: '/venue',
  path: '/venue',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsorsRoute = SponsorsRouteImport.update({
  id: '/sponsors',
  path: '/sponsors',
  getParentRoute: () => rootRouteImport,
} as any)
const SpeakersRoute = SpeakersRouteImport.update({
  id: '/speakers',
  path: '/speakers',
  getParentRoute: () => rootRouteImport,
} as any)
const PastEventsRoute = PastEventsRouteImport.update({
  id: '/past-events',
  path: '/past-events',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaRoute = AgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsorsSponsorIdRoute = SponsorsSponsorIdRouteImport.update({
  id: '/$sponsorId',
  path: '/$sponsorId',
  getParentRoute: () => SponsorsRoute,
} as any)
const SpeakersSpeakerIdRoute = SpeakersSpeakerIdRouteImport.update({
  id: '/$speakerId',
  path: '/$speakerId',
  getParentRoute: () => SpeakersRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVenueRoute = AdminVenueRouteImport.update({
  id: '/admin/venue',
  path: '/admin/venue',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSponsorsRoute = AdminSponsorsRouteImport.update({
  id: '/admin/sponsors',
  path: '/admin/sponsors',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSpeakersRoute = AdminSpeakersRouteImport.update({
  id: '/admin/speakers',
  path: '/admin/speakers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRegistrationsRoute = AdminRegistrationsRouteImport.update({
  id: '/admin/registrations',
  path: '/admin/registrations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMediaRoute = AdminMediaRouteImport.update({
  id: '/admin/media',
  path: '/admin/media',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminHomepageRoute = AdminHomepageRouteImport.update({
  id: '/admin/homepage',
  path: '/admin/homepage',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGalleryRoute = AdminGalleryRouteImport.update({
  id: '/admin/gallery',
  path: '/admin/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEventRoute = AdminEventRouteImport.update({
  id: '/admin/event',
  path: '/admin/event',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAgendaRoute = AdminAgendaRouteImport.update({
  id: '/admin/agenda',
  path: '/admin/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAboutRoute = AdminAboutRouteImport.update({
  id: '/admin/about',
  path: '/admin/about',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/agenda': typeof AgendaRoute
  '/contact': typeof ContactRoute
  '/gallery': typeof GalleryRoute
  '/past-events': typeof PastEventsRoute
  '/speakers': typeof SpeakersRouteWithChildren
  '/sponsors': typeof SponsorsRouteWithChildren
  '/venue': typeof VenueRoute
  '/admin/about': typeof AdminAboutRoute
  '/admin/agenda': typeof AdminAgendaRoute
  '/admin/event': typeof AdminEventRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/homepage': typeof AdminHomepageRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/media': typeof AdminMediaRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/speakers': typeof AdminSpeakersRoute
  '/admin/sponsors': typeof AdminSponsorsRoute
  '/admin/venue': typeof AdminVenueRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/speakers/$speakerId': typeof SpeakersSpeakerIdRoute
  '/sponsors/$sponsorId': typeof SponsorsSponsorIdRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/agenda': typeof AgendaRoute
  '/contact': typeof ContactRoute
  '/gallery': typeof GalleryRoute
  '/past-events': typeof PastEventsRoute
  '/speakers': typeof SpeakersRouteWithChildren
  '/sponsors': typeof SponsorsRouteWithChildren
  '/venue': typeof VenueRoute
  '/admin/about': typeof AdminAboutRoute
  '/admin/agenda': typeof AdminAgendaRoute
  '/admin/event': typeof AdminEventRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/homepage': typeof AdminHomepageRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/media': typeof AdminMediaRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/speakers': typeof AdminSpeakersRoute
  '/admin/sponsors': typeof AdminSponsorsRoute
  '/admin/venue': typeof AdminVenueRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/speakers/$speakerId': typeof SpeakersSpeakerIdRoute
  '/sponsors/$sponsorId': typeof SponsorsSponsorIdRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/agenda': typeof AgendaRoute
  '/contact': typeof ContactRoute
  '/gallery': typeof GalleryRoute
  '/past-events': typeof PastEventsRoute
  '/speakers': typeof SpeakersRouteWithChildren
  '/sponsors': typeof SponsorsRouteWithChildren
  '/venue': typeof VenueRoute
  '/admin/about': typeof AdminAboutRoute
  '/admin/agenda': typeof AdminAgendaRoute
  '/admin/event': typeof AdminEventRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/homepage': typeof AdminHomepageRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/media': typeof AdminMediaRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/speakers': typeof AdminSpeakersRoute
  '/admin/sponsors': typeof AdminSponsorsRoute
  '/admin/venue': typeof AdminVenueRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/speakers/$speakerId': typeof SpeakersSpeakerIdRoute
  '/sponsors/$sponsorId': typeof SponsorsSponsorIdRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/agenda'
    | '/contact'
    | '/gallery'
    | '/past-events'
    | '/speakers'
    | '/sponsors'
    | '/venue'
    | '/admin/about'
    | '/admin/agenda'
    | '/admin/event'
    | '/admin/gallery'
    | '/admin/homepage'
    | '/admin/login'
    | '/admin/media'
    | '/admin/registrations'
    | '/admin/speakers'
    | '/admin/sponsors'
    | '/admin/venue'
    | '/events/$eventId'
    | '/speakers/$speakerId'
    | '/sponsors/$sponsorId'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/agenda'
    | '/contact'
    | '/gallery'
    | '/past-events'
    | '/speakers'
    | '/sponsors'
    | '/venue'
    | '/admin/about'
    | '/admin/agenda'
    | '/admin/event'
    | '/admin/gallery'
    | '/admin/homepage'
    | '/admin/login'
    | '/admin/media'
    | '/admin/registrations'
    | '/admin/speakers'
    | '/admin/sponsors'
    | '/admin/venue'
    | '/events/$eventId'
    | '/speakers/$speakerId'
    | '/sponsors/$sponsorId'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/agenda'
    | '/contact'
    | '/gallery'
    | '/past-events'
    | '/speakers'
    | '/sponsors'
    | '/venue'
    | '/admin/about'
    | '/admin/agenda'
    | '/admin/event'
    | '/admin/gallery'
    | '/admin/homepage'
    | '/admin/login'
    | '/admin/media'
    | '/admin/registrations'
    | '/admin/speakers'
    | '/admin/sponsors'
    | '/admin/venue'
    | '/events/$eventId'
    | '/speakers/$speakerId'
    | '/sponsors/$sponsorId'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AgendaRoute: typeof AgendaRoute
  ContactRoute: typeof ContactRoute
  GalleryRoute: typeof GalleryRoute
  PastEventsRoute: typeof PastEventsRoute
  SpeakersRoute: typeof SpeakersRouteWithChildren
  SponsorsRoute: typeof SponsorsRouteWithChildren
  VenueRoute: typeof VenueRoute
  AdminAboutRoute: typeof AdminAboutRoute
  AdminAgendaRoute: typeof AdminAgendaRoute
  AdminEventRoute: typeof AdminEventRoute
  AdminGalleryRoute: typeof AdminGalleryRoute
  AdminHomepageRoute: typeof AdminHomepageRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMediaRoute: typeof AdminMediaRoute
  AdminRegistrationsRoute: typeof AdminRegistrationsRoute
  AdminSpeakersRoute: typeof AdminSpeakersRoute
  AdminSponsorsRoute: typeof AdminSponsorsRoute
  AdminVenueRoute: typeof AdminVenueRoute
  EventsEventIdRoute: typeof EventsEventIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/venue': {
      id: '/venue'
      path: '/venue'
      fullPath: '/venue'
      preLoaderRoute: typeof VenueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsors': {
      id: '/sponsors'
      path: '/sponsors'
      fullPath: '/sponsors'
      preLoaderRoute: typeof SponsorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/speakers': {
      id: '/speakers'
      path: '/speakers'
      fullPath: '/speakers'
      preLoaderRoute: typeof SpeakersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/past-events': {
      id: '/past-events'
      path: '/past-events'
      fullPath: '/past-events'
      preLoaderRoute: typeof PastEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda': {
      id: '/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsors/$sponsorId': {
      id: '/sponsors/$sponsorId'
      path: '/$sponsorId'
      fullPath: '/sponsors/$sponsorId'
      preLoaderRoute: typeof SponsorsSponsorIdRouteImport
      parentRoute: typeof SponsorsRoute
    }
    '/speakers/$speakerId': {
      id: '/speakers/$speakerId'
      path: '/$speakerId'
      fullPath: '/speakers/$speakerId'
      preLoaderRoute: typeof SpeakersSpeakerIdRouteImport
      parentRoute: typeof SpeakersRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/venue': {
      id: '/admin/venue'
      path: '/admin/venue'
      fullPath: '/admin/venue'
      preLoaderRoute: typeof AdminVenueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sponsors': {
      id: '/admin/sponsors'
      path: '/admin/sponsors'
      fullPath: '/admin/sponsors'
      preLoaderRoute: typeof AdminSponsorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/speakers': {
      id: '/admin/speakers'
      path: '/admin/speakers'
      fullPath: '/admin/speakers'
      preLoaderRoute: typeof AdminSpeakersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/registrations': {
      id: '/admin/registrations'
      path: '/admin/registrations'
      fullPath: '/admin/registrations'
      preLoaderRoute: typeof AdminRegistrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/media': {
      id: '/admin/media'
      path: '/admin/media'
      fullPath: '/admin/media'
      preLoaderRoute: typeof AdminMediaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/homepage': {
      id: '/admin/homepage'
      path: '/admin/homepage'
      fullPath: '/admin/homepage'
      preLoaderRoute: typeof AdminHomepageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/gallery': {
      id: '/admin/gallery'
      path: '/admin/gallery'
      fullPath: '/admin/gallery'
      preLoaderRoute: typeof AdminGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/event': {
      id: '/admin/event'
      path: '/admin/event'
      fullPath: '/admin/event'
      preLoaderRoute: typeof AdminEventRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/agenda': {
      id: '/admin/agenda'
      path: '/admin/agenda'
      fullPath: '/admin/agenda'
      preLoaderRoute: typeof AdminAgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/about': {
      id: '/admin/about'
      path: '/admin/about'
      fullPath: '/admin/about'
      preLoaderRoute: typeof AdminAboutRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SpeakersRouteChildren {
  SpeakersSpeakerIdRoute: typeof SpeakersSpeakerIdRoute
}

const SpeakersRouteChildren: SpeakersRouteChildren = {
  SpeakersSpeakerIdRoute: SpeakersSpeakerIdRoute,
}

const SpeakersRouteWithChildren = SpeakersRoute._addFileChildren(
  SpeakersRouteChildren,
)

interface SponsorsRouteChildren {
  SponsorsSponsorIdRoute: typeof SponsorsSponsorIdRoute
}

const SponsorsRouteChildren: SponsorsRouteChildren = {
  SponsorsSponsorIdRoute: SponsorsSponsorIdRoute,
}

const SponsorsRouteWithChildren = SponsorsRoute._addFileChildren(
  SponsorsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AgendaRoute: AgendaRoute,
  ContactRoute: ContactRoute,
  GalleryRoute: GalleryRoute,
  PastEventsRoute: PastEventsRoute,
  SpeakersRoute: SpeakersRouteWithChildren,
  SponsorsRoute: SponsorsRouteWithChildren,
  VenueRoute: VenueRoute,
  AdminAboutRoute: AdminAboutRoute,
  AdminAgendaRoute: AdminAgendaRoute,
  AdminEventRoute: AdminEventRoute,
  AdminGalleryRoute: AdminGalleryRoute,
  AdminHomepageRoute: AdminHomepageRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMediaRoute: AdminMediaRoute,
  AdminRegistrationsRoute: AdminRegistrationsRoute,
  AdminSpeakersRoute: AdminSpeakersRoute,
  AdminSponsorsRoute: AdminSponsorsRoute,
  AdminVenueRoute: AdminVenueRoute,
  EventsEventIdRoute: EventsEventIdRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
